import { z } from "zod";
import { parameterBaseSchema } from "./parameterBase.schema";
import { ParameterTypeEnum } from "./ParameterType.enum";

/**
 * Schema for quarter and year parameter
 */
export const yearSchema = parameterBaseSchema.merge(
    z.object({
        type: z.literal(ParameterTypeEnum.YEAR),
        name: z.string(),
        minInclusive: z.coerce.string(),
        maxInclusive: z.coerce.string(),
        path: z.string(),
        possibleValues: z.array(z.string()).optional(),
    })
);
